import { Component, OnInit, Input, ViewEncapsulation, OnChanges, SimpleChanges, SimpleChange, EventEmitter, Output, OnDestroy } from '@angular/core';
import { CommonService } from '../services/common.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-bottom-pop-over',
    templateUrl: './bottom-pop-over.component.html',
    styleUrls: ['./bottom-pop-over.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, TranslateModule]
})
export class BottomPopOverComponent implements OnInit, OnChanges, OnDestroy {
  @Input() delete;
  @Input() reverse;
  @Input() suggest;
  @Input() count;
  @Input() add;
  @Input() approve;
  @Input() deny;
  @Input() hold;
  @Input() message;
  @Input() sync;
  @Input() suspend;
  @Output() ClosePopOver: EventEmitter<any> = new EventEmitter();
  @Output() BatchCancel: EventEmitter<any> = new EventEmitter();
  @Output() AutoSuggest: EventEmitter<any> = new EventEmitter();
  @Output() AddItems: EventEmitter<any> = new EventEmitter();
  @Output() IconClick: EventEmitter<any> = new EventEmitter();
  @Output() syncClick: EventEmitter<any> = new EventEmitter();

  isShow = false;
  popOverMessage = false;
  disableSync = false;
  subcriber: any;
  itemPlural: string;
  constructor(private _cs: CommonService, private translateService: TranslateService) { }

  ngOnInit() {
    this.subcriber = this._cs.onlineStatusChange.subscribe((value) => {
      this.disableSync = !value;
    });
  }

  dismiss(event: Event) {
    this.isShow = false;
    this.ClosePopOver.emit(event);
  }

  ngOnChanges(changes: SimpleChanges) {
    const show: SimpleChange = changes.count;
    // this.isShow = show;
    if (this.message) {
      this.popOverMessage = true;
    }
    if (show) {
    if (show.currentValue > 0) {
      this.isShow = true;
      if (show.currentValue > 1) {
        this.itemPlural = this.translateService.instant('common.item');
      } else {
        this.itemPlural = this.translateService.instant('common.item');
      }
    } else {
      this.isShow = false;
    }
  }
  }


  batchCancel(event) {
    this.BatchCancel.emit(event);
  }

  autoSuggest(event) {
    this.AutoSuggest.emit(event);
  }

  addItems(event) {
    this.AddItems.emit(event);
  }

  iconClick(event, type) {
    this.IconClick.emit(type);
  }

  syncClicked(event) {
    this.syncClick.emit(event);
  }

  ngOnDestroy() {
    this.subcriber.unsubscribe();
  }
}
